import { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';

import theme from './index';

export const GlobalStyle = createGlobalStyle`
  ${reset}

  html {
    scroll-behavior: smooth;
    background: ${theme.colors.lightYellow};
  }

  body {
    font-family: 'F37Ginger', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1,
  h2 {
    font-size: 40px;
    font-weight: bold;
    line-height: inherit;
    color: ${theme.colors.darkBlue};
  }

  p {
    font-size: 20px;
    line-height: inherit;
    color: ${theme.colors.darkBlue};
    font-family: 'F37Ginger', sans-serif;
  }

  textarea {
    font-family: 'F37Ginger', sans-serif;
  }

  span {
    font-size: 12px;
    line-height: inherit;
    color: ${theme.colors.darkBlue};
  }

  .no-scroll {
    overflow: hidden;
  }

  button,
  input {
    font-family: 'F37Ginger', sans-serif;
  }

  input:-webkit-autofill {
    caret-color: ${theme.colors.funtainBlue};
    -webkit-text-fill-color: ${theme.colors.funtainBlue};
    box-shadow: 0 0 0 1000px ${theme.colors.white} inset;
    box-sizing: border-box;
  }
`;
